module.exports = " <div class=text _v-34cd3954=\"\"> <textarea placeholder=\"按 Ctrl + Enter 发送\" v-model=content @keyup=onKeyup _v-34cd3954=\"\"></textarea> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-34cd3954!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/text.vue
 ** module id = 321
 ** module chunks = 0
 **/